import { useState } from "react";
import styles from "./startTimer.module.css";
import { useEffect } from "react";

export const StartTimer = ({
      setShowGameStartTimer,
      game,
      setShowGame,
      setShowMenuOverlay,
}) => {
      const [time, setTime] = useState(3);
      const [timerId, setTimerId] = useState(null);

      useEffect(() => {
            const id = setInterval(() => {
                  setTime((previous) => {
                        return previous - 1;
                  });
            }, 900);
            setTimerId(id);
            game?.sounds?.countingSound.play();
      }, []);
      useEffect(() => {
            if (time === 0) {
                  clearTimeout(timerId);
                  setShowGameStartTimer(false);
                  game.start();
                  setShowGame(true);
            }
      }, [time]);

      useEffect(() => {
            const startTimerOutOfFocus = (event) => {
                  game.pause = true;

                  setShowMenuOverlay(true);
            };

            window.addEventListener("blur", startTimerOutOfFocus);
            return () => {
                  window.removeEventListener("blur", startTimerOutOfFocus);
            };
      }, []);

      return (
            <section className={styles["start-timer-section"]}>
                  <p className={styles["time"]}>{time}</p>
            </section>
      );
};
